module.exports = __webpack_public_path__ + "static/media/photoWho.02349f0c.jpg";